import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import ParticlesOverlay from 'components/LayoutComponents/ParticlesOverlay'

import './style.scss'

const NotFoundPage = () => {
  return (
    <ParticlesOverlay>
      <div className="not-found-page">
        <Helmet title="Not Found" />
        <div className="not-found-container">
          <div className="not-found-wrapper">
            <h1 className="font-size-36 mb-2">
              <FormattedMessage id="404.heading" />
            </h1>
            <p className="mb-3">
              <FormattedMessage id="404.description" />
            </p>
            <h1 className="font-size-80 mb-4 font-weight-bold">404 —</h1>
            <Link to="/" className="btn">
              &larr; <FormattedMessage id="404.goBack" />
            </Link>
          </div>
        </div>
      </div>
    </ParticlesOverlay>
  )
}

export default NotFoundPage
